function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(url);
    image.onerror = () => reject();
    image.src = url;
  });
}

async function findWorkingUrl(urls) {
  let index = 0;
  while (index < urls.length) {
    try {
      // eslint-disable-next-line no-await-in-loop
      return await loadImage(urls[index]);
    } catch {
      index += 1;
    }
  }
  throw new Error('No working URL found');
}

export default findWorkingUrl;
